import { render, staticRenderFns } from "./supportlog.vue?vue&type=template&id=593cfe54&scoped=true"
import script from "./supportlog.vue?vue&type=script&lang=js"
export * from "./supportlog.vue?vue&type=script&lang=js"
import style0 from "./supportlog.vue?vue&type=style&index=0&id=593cfe54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593cfe54",
  null
  
)

export default component.exports